import React, { useState, useEffect } from 'react';
import HeroSection from './HeroSection';
import TrustIndicators from './TrustIndicators';
import PreviewSection from './PreviewSection';
import FeatureGrid from './FeatureGrid';
import BenefitsSection from './BenefitsSection';
import TestimonialsSection from './TestimonialsSection';
import PricingSection from './PricingSection';
import CTASection from './CTASection';
import TenantRequestForm from './TenantRequestForm';
import Layout from 'layouts/Landing/SaaS/SaaSLandingLayout';

const SaaSLandingPage: React.FC = () => {
  const [openAccordion, setOpenAccordion] = useState<string>('');
  const [isNavOpen, setIsNavOpen] = useState<boolean>(false);
  const [isScrolled, setIsScrolled] = useState<boolean>(true);

  const toggleAccordion = (id: string) => {
    setOpenAccordion(openAccordion === id ? '' : id);
  };

  const toggleNav = () => {
    setIsNavOpen(!isNavOpen);
  };

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <Layout isScrolled={isScrolled} isNavOpen={isNavOpen} toggleNav={toggleNav}>
      <HeroSection />
      <TrustIndicators />
      <PreviewSection />
      <FeatureGrid />
      <BenefitsSection />
      <TestimonialsSection />
      <PricingSection openAccordion={openAccordion} toggleAccordion={toggleAccordion} />
      <CTASection />
      <TenantRequestForm />
    </Layout>
  );
};

export default SaaSLandingPage;
